<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Conta</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nomeConta"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Nome')"
            :class="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Banco</span>
          <v-select
            :options="bancos"
            name="Banco"
            id="Banco"
            v-model="formCadastro.idBanco"
            v-validate="{ required: true }"
            :state="validateState('Banco')"
            :class="validateClass('Banco')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span>Agência</span>
          <vs-input
            size="large"
            class="w-full"
            name="Agência"
            id="Agência"
            v-model="formCadastro.agencia"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Agência')"
            :class="validateClass('Agência')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span>Digito</span>
          <vs-input
            size="large"
            class="w-full"
            name="Digito Agência"
            id="Digito Agência"
            v-model="formCadastro.digitoAgencia"
            :state="validateState('Digito Agência')"
            :class="validateClass('Digito Agência')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span>Conta</span>
          <vs-input
            size="large"
            class="w-full"
            name="Conta"
            id="Conta"
            v-model="formCadastro.conta"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Conta')"
            :class="validateClass('Conta')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span>Digito</span>
          <vs-input
            size="large"
            class="w-full"
            name="Digito Conta"
            id="Digito Conta"
            v-model="formCadastro.digitoConta"
            :state="validateState('Digito Conta')"
            :class="validateClass('Digito Conta')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idConta == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      bancos: [],
      formCadastro: {
        idConta: null,
        idEmpresa: null,
        idBanco: null,
        status: true,
        nomeConta: '',
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dados.idConta) {
        this.formCadastro.idConta = this.dados.idConta;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nomeConta = this.dados.nomeConta;
        this.formCadastro.agencia = this.dados.agencia;
        this.formCadastro.digitoAgencia = this.dados.digitoAgencia;
        this.formCadastro.conta = this.dados.conta;
        this.formCadastro.digitoConta = this.dados.digitoConta;
        this.formCadastro.idBanco = {
          id: this.dados.idBanco,
          label: this.dados.nomeBanco,
        };
      } else {
        this.resetForm();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref) ? 'has-error' : '';
      }
      return null;
    },
    validateStyle(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return {
          border: '1px solid red !important',
          borderRadius: '5px',
        };
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idConta) {
        action = 'Adicionar';
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('ContaBancaria', action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (model == 'domBancos') {
            this[array].push({
              id: element[campoPK],
              label: element.COMPE + ' - ' + element[campoDescricao],
            });
          }
        });
      });
    },

    resetForm() {
      this.formCadastro = {
        idConta: null,
        idEmpresa: null,
        status: true,
        nomeConta: '',
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  mounted() {
    this.buscaDadosSelects('domBancos', 'bancos', 'shortName', 'idBanco');
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
